import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAProductEnquiry,
  updateAProductEnquiry,
} from "../features/productEnquiry/productEnquirySlice";
import { BiArrowBack } from "react-icons/bi";
import { resolveMediaUrl } from "../utils/mediaUrl";

const ViewProductEnquiry = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getEnqId = location.pathname.split("/")[3];
  const enqState = useSelector((state) => state.productEnquiry);
  
  const {
    enquiryName,
    enquiryMobile,
    enquiryEmail,
    enquiryProductName,
    enquiryDesignCode,
    enquiryImg,
    enquiryUrl,
    enquiryStatus,
  } = enqState;

  useEffect(() => {
    dispatch(getAProductEnquiry(getEnqId));
  }, [getEnqId, dispatch]);

  const goBack = () => {
    navigate(-1);
  };

  const setEnquiryStatus = (e, i) => {
    const data = { id: i, enquiryData: e };
    dispatch(updateAProductEnquiry(data));
    setTimeout(() => {
      dispatch(getAProductEnquiry(getEnqId));
    }, 100);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View Product Enquiry</h3>
        <button
          className="bg-transparent border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5" /> Go Back
        </button>
      </div>
      <div className="mt-5 bg-white p-4 d-flex gap-3 flex-column rounded-3">
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Customer Name:</h6>
          <p className="mb-0">{enquiryName}</p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Mobile:</h6>
          <p className="mb-0">
            <a href={`tel:+91${enquiryMobile}`}>{enquiryMobile}</a>
          </p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Email:</h6>
          <p className="mb-0">
            <a href={`mailto:${enquiryEmail}`}>{enquiryEmail}</a>
          </p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Product Name:</h6>
          <p className="mb-0">{enquiryProductName}</p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">SKU / Design Code:</h6>
          <p className="mb-0">{enquiryDesignCode || 'N/A'}</p>
        </div>
        {enquiryUrl && (
          <div className="d-flex align-items-center gap-3">
            <h6 className="mb-0">Product Link:</h6>
            <p className="mb-0">
              <a href={enquiryUrl} target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#1890ff' }}>
                Open Product Page
              </a>
            </p>
          </div>
        )}
        <div className="d-flex align-items-start gap-3">
          <h6 className="mb-0 mt-1">Product Image:</h6>
          <div>
            {enquiryImg ? (
              <img
                src={resolveMediaUrl(enquiryImg)}
                alt={enquiryProductName}
                width={200}
                height={200}
                style={{ objectFit: 'contain', borderRadius: '8px', border: '1px solid #eee' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "default-product-img.png"; // Fallback image
                }}
              />
            ) : (
              <p className="mb-0 text-muted">No Image Available</p>
            )}
          </div>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Current Status:</h6>
          <p className="mb-0">{enquiryStatus}</p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <h6 className="mb-0">Change Status:</h6>
          <div>
            <select
              name=""
              value={enquiryStatus ? enquiryStatus : "Submitted"}
              className="form-control form-select"
              id=""
              onChange={(e) => setEnquiryStatus(e.target.value, getEnqId)}
            >
              <option value="Submitted">Submitted</option>
              <option value="Contacted">Contacted</option>
              <option value="In Progress">In Progress</option>
              <option value="Resolved">Resolved</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProductEnquiry;
